import React from 'react';

export interface CustomerItem {
  customerCode: string;
}

interface CustomerSelectProps {
  customers?: CustomerItem[];
  value?: string;
  onChange: (customerCode: string) => void;
}

function CustomerSelect({ customers, value, onChange }: CustomerSelectProps) {
  if (!customers || customers.length <= 1) {
    return null;
  }

  return (
    <div className="fase-monitor__select-wrap">
      <select
        id="fase-customer-select"
        className="fase-monitor__select"
        aria-label="Select airline"
        value={value || ''}
        onChange={(event) => onChange(event.target.value)}
      >
        {customers.map((customer) => (
          <option key={customer.customerCode} value={customer.customerCode}>
            {customer.customerCode}
          </option>
        ))}
      </select>
    </div>
  );
}

export default CustomerSelect;
